import { autoserialize, autoserializeAs } from 'cerialize';

export class Emergency {
  @autoserialize id!: string;
  @autoserializeAs('emergency_label')  label!: string;
  @autoserializeAs('emergency_priority') priority!: number;
  @autoserializeAs('emergency_level') level!: number;
  @autoserializeAs('hex_color')  color!: string;
  @autoserialize creator!: string;
}
